import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';

@Injectable({ providedIn: 'root' })
export class CategoryDataService extends EntityCollectionServiceBase<any> {
    [x: string]: any;
    headers: { [key: string]: string } = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Access-Control-Allow-Origin': '*',
    };

    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('Category', serviceElementsFactory);
    }

    setHeaders(headers: { [key: string]: string }) {
        this.headers = {
            ...this.headers,
            ...headers,
        };
    }
}
